import type { ApiAnyDisplayError } from './types';
import { ApiCommonError } from './types';

export class ApiBaseError extends Error {
  constructor(message?: string, public displayError?: ApiAnyDisplayError) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class ApiUserRejectsError extends ApiBaseError {
  constructor(message: string = 'Canceled by the user') {
    super(message);
  }
}

export class ApiServerError extends ApiBaseError {
  constructor(message: string, public statusCode?: number, public code?: string) {
    super(message, ApiCommonError.ServerError);
  }
}

const WALLET_DISCOVERY_RECOVERABLE_FETCH_ERRORS = new Set([
  'Failed to fetch', // Chromium
  'NetworkError when attempting to fetch resource.', // Firefox (console shows "TypeError: …")
  'Load failed', // Safari
]);

export function isWalletDiscoveryRecoverableTransportError(err: unknown): boolean {
  // Check for the error text to catch specific offline-import case.
  return err instanceof ApiServerError
    || (err instanceof TypeError && WALLET_DISCOVERY_RECOVERABLE_FETCH_ERRORS.has(err.message));
}

export class AbortOperationError extends ApiBaseError {
  constructor(message: string = 'Abort operation') {
    super(message);
  }
}

export class NotImplemented extends ApiBaseError {
  constructor(message: string = 'Not implemented') {
    super(message);
  }
}

export function maybeApiErrors(fn: AnyAsyncFunction) {
  return async (...args: any) => {
    try {
      return await fn(...args);
    } catch (err) {
      return handleServerError(err);
    }
  };
}

export function handleServerError(err: any) {
  if (err instanceof ApiServerError) {
    return { error: err.displayError! };
  }
  throw err;
}
